import { render } from "./ChartsGridConfiger.vue?vue&type=template&id=f96aab62&scoped=true"
import script from "./ChartsGridConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsGridConfiger.vue?vue&type=script&lang=js"

import "./ChartsGridConfiger.vue?vue&type=style&index=0&id=f96aab62&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96aab62"]])

export default __exports__